import $ from 'jquery';

$(document).ready(_ => {
    $(".js-error").slideUp(0);
    $(".js-success").slideUp(0);
});

export function setInputState(myId, state, message) {
    switch (state) {
        case "error":
            $(myId).removeClass("border-success");
            $(myId).addClass("border-2 border-danger border");
            $(myId).closest(".js-label").parent().each(function () {
                if (message != undefined) {
                    $(this).find(".js-error").html(message);
                }
                $(this).find(".js-success, .js-neutral").slideUp();
                $(this).find(".js-error").slideDown();
            });
            break;
        case  "success":
            $(myId).removeClass("border-danger");
            $(myId).addClass("border-2 border-success border");
            $(myId).closest(".js-label").parent().each(function () {
                if (message != undefined) {
                    $(this).find(".js-success").html(message);
                }
                $(this).find(".js-error, .js-neutral").slideUp();
                $(this).find(".js-success").slideDown();
                $(this).find(".php-error").slideUp();
            });
            break;
        default: //reset to base state
            $(myId).removeClass("border").removeClass("border-2").removeClass("border-danger").removeClass("border-success");
            $(myId).closest(".js-label").parent().each(function () {
                $(this).find(".js-success, .js-error").slideUp();
                $(this).find(".php-error").slideUp();
                if (message != undefined) {
                    $(this).find(".js-neutral").html(message).slideDown();
                }
            });
    }
}

//remove php errors after input changes to a value
$('.form-label .border-danger').on('change', function(){

    $(this).closest(".form-label").parent().each(function () {
      $(this).find(".php-error").slideUp();
    });
  
});
